<div class="self-exclusion">
  <h2 class="title">Self-Exclusion</h2>
  <p class="description">
    Take a break from betting. Once submitted, your account is locked for the selected duration and
    <strong>staff cannot lift this ban early.</strong>
  </p>

  <!--
    TODO(migration): duration labels below assume the BE's `self_ban` "time" field is HOURS.
    This is unverified — confirm with BE before shipping these labels as user-facing (60x risk
    if the BE actually expects minutes). See spec AC-22.
  -->
  <div class="duration-options">
    @for (option of durationOptions; track option.hours) {
    <button type="button" class="duration-option" [class.active]="selectedDuration() === option.hours" (click)="selectDuration(option.hours)">
      {{ option.label }}
    </button>
    }
  </div>

  <div class="option checkbox-group" (click)="toggleUnderstand()">
    <input class="checkbox" type="checkbox" [checked]="understandsConsequences()" />
    <label>I understand staff cannot lift this ban.</label>
  </div>

  <button type="button" class="button red submit-button" [disabled]="!canSubmit()" (click)="submit()">
    {{ submitting() ? 'Submitting...' : 'Confirm Self-Exclusion' }}
  </button>
</div>
